'use client'

import type { ComponentProps } from 'react'
import { BlurFade } from '@/components/ui/blur-fade'
import { useTemplatesSurface } from '../lib/templates-surface-context'

/** App cards are already loaded; keep them visible before hydration. */
export function TemplateGridReveal(
  props: Pick<
    ComponentProps<typeof BlurFade>,
    'children' | 'className' | 'delay' | 'inView'
  >
) {
  const surface = useTemplatesSurface()
  if (surface === 'app') {
    return <div className={props.className}>{props.children}</div>
  }
  return <BlurFade {...props} />
}
